import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ServerConnectionService} from "./server-connection.service";
import {UserService} from "./user.service";
import {CookieService} from "ng2-cookies";

@Injectable({
  providedIn: 'root'
})
export class HttpClientService {

  private url: string;

  constructor(private http: HttpClient, private serverConnection: ServerConnectionService,
              private cookieService: CookieService) {
    this.url = serverConnection.getUrlServer();
  }

  public createAuthorizationHeader() {
    return new HttpHeaders().set("Authorization", this.cookieService.get("token"));
  }

  public get(path) {
    let headers = this.createAuthorizationHeader();
    return this.http.get(this.url + path, {
      headers: headers
    });
  }

  public getText(path) {
    let headers = this.createAuthorizationHeader();
    return this.http.get(this.url + path, {
      headers: headers,
      responseType: 'text' as 'text'
    });
  }

  public getWithParams(path, params) {
    let headers = this.createAuthorizationHeader();
    return this.http.get(this.url + path, {
      params: params,
      headers: headers
    });
  }

  public post(path, data) {
    let headers = this.createAuthorizationHeader();
    return this.http.post(this.url + path, data, {
      headers: headers,
      responseType: 'text'
    });
  }

  public postResponseJSON(path, data) {
    let headers = this.createAuthorizationHeader();
    return this.http.post(this.url + path, data, {
      headers: headers,
      responseType: 'json'
    });
  }

  public patch(path, data) {
    let headers = this.createAuthorizationHeader();
    return this.http.patch(this.url + path, data, {
      headers: headers,
      responseType: 'text'
    });
  }

  public delete(path) {
    let headers = this.createAuthorizationHeader();
    return this.http.delete(this.url + path, {
      headers: headers,
      responseType: 'text'
    });
  }

  public deleteWithParams(path, params) {
    let headers = this.createAuthorizationHeader();
    return this.http.delete(this.url + path, {
      params: params,
      headers: headers,
      responseType: 'text'
    });
  }
}